webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(31);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(90);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(253);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(213);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(94);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(91);
	
	var _vClickOutside = __webpack_require__(212);
	
	var _vClickOutside2 = _interopRequireDefault(_vClickOutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vClickOutside2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes.routes,
	  mode: 'history'
	});
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  router: router,
	  store: _store2.default
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports.scrubMixin = scrubMixin;
	
	function scrubMixin() {
	  return {
	    methods: {
	      scrub: function scrub(slug) {
	        return encodeURIComponent(slug);
	      }
	    }
	  };
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(119);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(120);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vue = __webpack_require__(31);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _util = __webpack_require__(32);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_REQUEST_SIZE = 1000;
	
	var EXCLUDE_HIDDEN = 'AND NOT flags.hide-from-search:true';
	
	function escapeCategory(cat) {
	  if (!cat) {
	    return cat;
	  }
	  return encodeURIComponent(cat).replace(/%20/g, '\\%20');
	}
	
	var ProtocolsDB = function () {
	  function ProtocolsDB() {
	    (0, _classCallCheck3.default)(this, ProtocolsDB);
	
	    this.baseUrl = 'https://search-protocol-library-vtnb4isrcwl533qbttgesbtmny.us-west-2.es.amazonaws.com/';
	    this.protocolsIndexUrl = this.baseUrl + _util2.default.appendBranchSuffix('protocols') + '/protocol/';
	    this.protocolsIndexSearchUrl = this.baseUrl + _util2.default.appendBranchSuffix('protocols') + '/protocol/_search/';
	    this.categoriesIndexUrl = this.baseUrl + _util2.default.appendBranchSuffix('categories') + '/category/';
	  }
	
	  (0, _createClass3.default)(ProtocolsDB, [{
	    key: 'getCategories',
	    value: function getCategories() {
	      return _vue2.default.http.get(this.categoriesIndexUrl + '0').then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getFeaturedProtocols',
	    value: function getFeaturedProtocols() {
	      return _vue2.default.http.get(this.protocolsIndexSearchUrl, { params: { q: 'flags.feature:true ' + EXCLUDE_HIDDEN } }).then(function (response) {
	        return response.data.hits.hits;
	      });
	    }
	  }, {
	    key: 'queryProtocols',
	    value: function queryProtocols(query) {
	      return _vue2.default.http.get(this.protocolsIndexSearchUrl, { params: { q: query + ' ' + EXCLUDE_HIDDEN, size: MAX_REQUEST_SIZE } }).then(function (response) {
	        return response.data.hits.hits;
	      });
	    }
	  }, {
	    key: 'getProtocol',
	    value: function getProtocol(protocolSlug) {
	      return _vue2.default.http.get(this.protocolsIndexUrl + protocolSlug).then(function (response) {
	        return response.data._source;
	      });
	    }
	  }, {
	    key: 'getProtocolsByCategory',
	    value: function getProtocolsByCategory(rawCategory, rawSubCategory) {
	      var query = null;
	      var category = escapeCategory(rawCategory);
	      var subCategory = escapeCategory(rawSubCategory);
	
	      if (category && subCategory) {
	        query = '(categories.' + category + ':"' + subCategory + '")';
	      } else if (category) {
	        query = '(categories.' + category + ')';
	      } else {
	        console.error('Must provide category (and optionally) subcategory argument');
	        query = '*';
	      }
	
	      return _vue2.default.http.get(this.protocolsIndexSearchUrl + ('?q=' + query + ' ' + EXCLUDE_HIDDEN + '&size=' + MAX_REQUEST_SIZE)).then(function (response) {
	        return response.data.hits.hits;
	      });
	    }
	  }]);
	  return ProtocolsDB;
	}();
	
	exports.default = new ProtocolsDB();

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var branchName = ("master");
	var branchSuffix = function branchSuffix(name) {
	  return name === 'master' ? '' : '-' + name;
	};
	var appendBranchSuffix = function appendBranchSuffix(name) {
	  return encodeURIComponent(name + branchSuffix(("master")));
	};
	
	var createIframeListener = function createIframeListener(iframeId) {
	  return window.addEventListener('message', function (e) {
	    var origin = e.origin || e.originalEvent.origin;
	
	    console.log('parent received message!:  ', e.data.type, { data: e.data, origin: origin, e: e });
	
	    var iframe = document.getElementById(iframeId);
	    if (iframe === null) {
	      console.log('No iframe found with id', iframeId);
	    } else {
	      if (e.data.type === 'SCROLL_TO_TOP') {
	        var iframeYPos = document.getElementById('embedded-app').getBoundingClientRect().top;
	        var navHeight = document.getElementById('nav').offsetHeight;
	        window.scrollTo(0, iframeYPos + window.pageYOffset - navHeight);
	      }
	    }
	  }, false);
	};
	
	exports.default = {
	  branchSuffix: branchSuffix,
	  appendBranchSuffix: appendBranchSuffix,
	  branchName: branchName,
	  createIframeListener: createIframeListener
	};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(99),
	  /* template */
	  __webpack_require__(243),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UPDATE_CATEGORIES = exports.UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
	var UPDATE_PROTOCOLS = exports.UPDATE_PROTOCOLS = 'UPDATE_PROTOCOLS';
	var SELECT_PROTOCOL = exports.SELECT_PROTOCOL = 'SELECT_PROTOCOL';

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(96),
	  /* template */
	  __webpack_require__(234),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(98),
	  /* template */
	  __webpack_require__(244),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(106),
	  /* template */
	  __webpack_require__(242),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _LandingView = __webpack_require__(219);
	
	var _LandingView2 = _interopRequireDefault(_LandingView);
	
	var _ResultsView = __webpack_require__(226);
	
	var _ResultsView2 = _interopRequireDefault(_ResultsView);
	
	var _ProtocolView = __webpack_require__(224);
	
	var _ProtocolView2 = _interopRequireDefault(_ProtocolView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = exports.routes = [{ path: '/', name: 'home', component: _LandingView2.default }, { path: '/categories/:category/:subCategory?', name: 'category-query', component: _ResultsView2.default }, { path: '/search/', name: 'search-query', component: _ResultsView2.default }, { path: '/protocol/:slug', name: 'protocol', component: _ProtocolView2.default }];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(31);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(90);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _mutationTypes = __webpack_require__(49);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _db = __webpack_require__(19);
	
	var _db2 = _interopRequireDefault(_db);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var actions = {
	  initCategories: function initCategories(_ref) {
	    var commit = _ref.commit;
	
	    _db2.default.getCategories().then(function (response) {
	      var categories = response._source;
	      commit(types.UPDATE_CATEGORIES, { categories: categories });
	    });
	  },
	  queryProtocols: function queryProtocols(_ref2, query) {
	    var commit = _ref2.commit;
	
	    var params = { params: { q: query } };
	    console.log(params);
	    _db2.default.queryProtocols(params).then(function (response) {
	      var protocols = response.hits.hits;
	      commit(types.UPDATE_PROTOCOLS, { protocols: protocols });
	    });
	  }
	};
	
	var getters = {
	  categories: function categories(state) {
	    return state.categories;
	  }
	};
	
	exports.default = {
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(34);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(49);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  categories: [],
	  protocols: [],
	  protocol: {}
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.UPDATE_CATEGORIES, function (state, payload) {
	  state.categories = payload.categories;
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_PROTOCOLS, function (state, payload) {
	  state.protocols = payload.protocols;
	}), (0, _defineProperty3.default)(_mutations, types.SELECT_PROTOCOL, function (state, payload) {
	  state.protocol = payload.data;
	}), _mutations);
	
	exports.default = {
	  mutations: mutations,
	  state: state
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(31);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(254);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(93);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(92);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var mutations = _mutations2.default.mutations,
	    state = _mutations2.default.state;
	var actions = _actions2.default.actions,
	    getters = _actions2.default.getters;
	exports.default = new _vuex2.default.Store({
	  state: state,
	  actions: actions,
	  getters: getters,
	  mutations: mutations
	});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navigation = __webpack_require__(220);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SearchBar = __webpack_require__(227);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _SiteFooter = __webpack_require__(229);
	
	var _SiteFooter2 = _interopRequireDefault(_SiteFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Navigation: _Navigation2.default,
	    SearchBar: _SearchBar2.default,
	    SiteFooter: _SiteFooter2.default
	  },
	  beforeCreate: function beforeCreate() {
	    this.$store.dispatch('initCategories');
	  }
	};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'AppLink',
	  props: ['link', 'homeUrl', 'description'],
	  data: function data() {
	    return {
	      name: this.link.name,
	      url: this.link.url,
	      gtm: this.link.gtm,
	      linkout: this.link.linkout
	    };
	  }
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(116);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _entries = __webpack_require__(118);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Breadcrumb',
	  props: ['categories', 'protocol'],
	  methods: {
	    getProtocolCategories: function getProtocolCategories(protocol) {
	      var first = (0, _entries2.default)(protocol['categories'])[0];
	      var category = first[0];
	      var subCategory = first[1][0];
	      return [category, subCategory].filter(function (o) {
	        return o;
	      });
	    }
	  },
	  computed: {
	    myCategories: function myCategories() {
	      var c = (this.categories || []).filter(function (o) {
	        return o;
	      });
	      return c.length > 0 ? c : this.getProtocolCategories(this.protocol);
	    },
	    links: function links() {
	      var names = this.myCategories;
	      var url = '/categories/';
	      var res = [{ url: '/', name: 'Protocol Library' }];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(names), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var name = _step.value;
	
	          url += encodeURIComponent(name) + '/';
	          res.push({ url: url, name: name });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return res;
	    }
	  }
	};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CalloutDocs',
	  methods: {
	    openChat: function openChat() {
	      Intercom('showNewMessage', 'I would like to inquire about custom protocols');
	    }
	  }
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mixins = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Categories',
	  mixins: [(0, _mixins.scrubMixin)()],
	  methods: {
	    categories: function categories() {
	      return (0, _keys2.default)(this.$store.getters.categories).sort();
	    },
	    subCategories: function subCategories(category) {
	      return this.$store.getters.categories[category];
	    }
	  }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Container',
	  props: ['placeable'],
	  data: function data() {
	    return {
	      show: false,
	      img: this.placeable.type + '.png'
	    };
	  },
	
	  methods: {
	    containerImg: function containerImg() {
	      var type = this.placeable.type;
	      var url = 'https://s3.amazonaws.com/opentrons-images/website/labware/';
	      if (type.includes('96')) {
	        return url + '96-plate.png';
	      }
	      return url + type + '.png';
	    },
	    addDefaultSrc: function addDefaultSrc(e) {
	      e.target.src = 'https://s3.amazonaws.com/opentrons-images/website/labware/custom.png';
	    }
	  }
	};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iframeResizer = __webpack_require__(169);
	
	var _util = __webpack_require__(32);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ProtocolView',
	  props: ['src'],
	  mounted: function mounted() {
	    (0, _iframeResizer.iframeResizer)({
	      log: ("production") === 'development',
	      checkOrigin: false }, '#embedded-app');
	
	    _util2.default.createIframeListener('embedded-app');
	  }
	};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Error404Page'
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showdown = __webpack_require__(46);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FeaturedProtocol',
	  props: ['protocol'],
	  methods: {
	    makeHtml: function makeHtml(markdownText) {
	      return new _showdown2.default.Converter().makeHtml(markdownText);
	    },
	    info: function info(key) {
	      return this.protocol._source[key];
	    },
	    hasContent: function hasContent(key) {
	      return this.protocol._source[key] !== '';
	    }
	  }
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Categories = __webpack_require__(48);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _FeaturedProtocol = __webpack_require__(218);
	
	var _FeaturedProtocol2 = _interopRequireDefault(_FeaturedProtocol);
	
	var _RecentlyAdded = __webpack_require__(225);
	
	var _RecentlyAdded2 = _interopRequireDefault(_RecentlyAdded);
	
	var _CalloutDocs = __webpack_require__(88);
	
	var _CalloutDocs2 = _interopRequireDefault(_CalloutDocs);
	
	var _UpdateBanner = __webpack_require__(230);
	
	var _UpdateBanner2 = _interopRequireDefault(_UpdateBanner);
	
	var _db = __webpack_require__(19);
	
	var _db2 = _interopRequireDefault(_db);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'LandingView',
	  components: {
	    Categories: _Categories2.default,
	    FeaturedProtocol: _FeaturedProtocol2.default,
	    RecentlyAdded: _RecentlyAdded2.default,
	    CalloutDocs: _CalloutDocs2.default,
	    UpdateBanner: _UpdateBanner2.default
	  },
	  data: function data() {
	    return {
	      featuredProtocols: []
	    };
	  },
	  created: function created() {
	    this.fetchFeaturedProtocols();
	  },
	
	  watch: {
	    '$route': 'fetchFeaturedProtocols'
	  },
	  methods: {
	    fetchFeaturedProtocols: function fetchFeaturedProtocols() {
	      var that = this;
	      _db2.default.getFeaturedProtocols().then(function (protocols) {
	        that.featuredProtocols = protocols;
	      });
	    }
	  }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nav = __webpack_require__(174);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _NavigationSub = __webpack_require__(89);
	
	var _NavigationSub2 = _interopRequireDefault(_NavigationSub);
	
	var _AppLink = __webpack_require__(87);
	
	var _AppLink2 = _interopRequireDefault(_AppLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Navigation',
	  components: {
	    AppLink: _AppLink2.default,
	    NavigationSub: _NavigationSub2.default
	  },
	  data: function data() {
	    return {
	      subdomainList: _nav2.default.subdomainList,
	      navigationList: _nav2.default.navigationList,
	      homeUrl: _nav2.default.homeUrl,
	      activeName: '',
	      activeNameDelay: '',
	      mobileMenu: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    window.fetch('https://opentrons.com/api/navigationData.json').then(function (response) {
	      response.json().then(function (data) {
	        if (data && data.homeUrl) {
	          _this.subdomainList = data.subdomainList;
	          _this.navigationList = data.navigationList;
	          _this.homeUrl = data.homeUrl;
	        }
	      });
	    }).catch(function (e) {
	      return console.error(e);
	    });
	  },
	
	  methods: {
	    handleItemClick: function handleItemClick(name) {
	      var _this2 = this;
	
	      if (name === this.activeName) {
	        this.activeName = '';
	        this.activeNameDelay = '';
	      } else {
	        this.activeName = name;
	        setTimeout(function () {
	          _this2.activeNameDelay = name;
	        }, 100);
	      }
	    },
	    handleBurgerClick: function handleBurgerClick() {
	      if (this.mobileMenu === false) {
	        document.body !== null && document.body.classList.add('no_scroll');
	      } else {
	        document.body !== null && document.body.classList.remove('no_scroll');
	      }
	      this.mobileMenu = !this.mobileMenu;
	    }
	  }
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationSub = __webpack_require__(89);
	
	var _NavigationSub2 = _interopRequireDefault(_NavigationSub);
	
	var _AppLink = __webpack_require__(87);
	
	var _AppLink2 = _interopRequireDefault(_AppLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NavigationSub',
	  components: {
	    AppLink: _AppLink2.default,
	    NavigationSub: _NavigationSub2.default
	  },
	  props: ['subitem', 'homeUrl'],
	  data: function data() {
	    return {
	      name: this.subitem.name,
	      links: this.subitem.links,
	      url: this.subitem.url,
	      description: this.subitem.description
	    };
	  }
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(34);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(52);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _fileSaver = __webpack_require__(167);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _jszip = __webpack_require__(178);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ParameterizeAndDownload',
	  props: ['downloadUrl', 'protocolData', 'protocolSlug', 'robotTab'],
	  data: function data() {
	    return {
	      fieldValues: {}
	    };
	  },
	  beforeMount: function beforeMount() {
	    var fields = this.protocolData.fields;
	    if (fields) {
	      var nextValues = fields.reduce(function (acc, param) {
	        return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, param.name, param.options ? param.options[0].value : param.default));
	      }, {});
	      this.fieldValues = nextValues;
	    }
	  },
	  methods: {
	    updateFile: function updateFile(e, fieldName) {
	      var _this = this;
	
	      var reader = new window.FileReader();
	
	      reader.onload = function (f) {
	        var fileContents = f.target.result;
	        _this.fieldValues[fieldName] = fileContents;
	      };
	      reader.readAsText(e.target.files[0]);
	    },
	    onDownload: function onDownload(e) {
	      var _this2 = this;
	
	      var getValuesFn = 'def get_values(*names):\n    import json\n    _all_values = json.loads("""' + (0, _stringify2.default)(this.fieldValues).replace(/\\n/g, '\\\\n').replace(/\\r/g, '') + '""")\n    return [_all_values[n] for n in names]';
	
	      var protocolContent = this.protocolData.content;
	      var customLabwareDefs = this.protocolData.customLabwareDefs;
	
	      var finalPyFile = getValuesFn + '\n\n\n' + protocolContent;
	      var pyFileName = this.protocolSlug + '.py';
	
	      if (customLabwareDefs.length > 0) {
	        var zip = new _jszip2.default();
	        zip.file(pyFileName, finalPyFile);
	
	        zip.file('.bundle_beta', '2019-09-18');
	
	        var labwareFolder = zip.folder('custom_labware');
	        customLabwareDefs.forEach(function (def) {
	          labwareFolder.file(def.metadata.displayName + '.json', (0, _stringify2.default)(def));
	        });
	        zip.generateAsync({ type: 'blob' }).then(function (content) {
	          return _fileSaver2.default.saveAs(content, _this2.protocolSlug + '.zip');
	        });
	      } else {
	        var blob = new Blob([finalPyFile], { type: 'text/plain;charset=utf-8' });
	        _fileSaver2.default.saveAs(blob, pyFileName);
	      }
	    }
	  },
	  computed: {
	    subdomain: function subdomain() {
	      var subdomain = window.location.href.split('://')[1].split('.')[0];
	
	      return subdomain === 'protocols' ? 'master' : subdomain;
	    },
	    protocolFields: function protocolFields() {
	      var fields = this.protocolData.fields;
	      if (!fields) {
	        return;
	      }
	
	      return fields.map(function (param) {
	        if (param.type === 'dropDown') {
	          return {
	            htmlElem: 'select',
	            default: param.options[0].value,
	            label: param.label,
	            name: param.name,
	            options: param.options
	          };
	        }
	
	        var stepVals = { int: '1', float: 'any' };
	
	        var inputTypes = {
	          int: 'number',
	          float: 'number',
	          str: 'text',
	          textFile: 'file'
	        };
	
	        return {
	          htmlElem: 'input',
	          castToNumber: ['int', 'float'].includes(param.type),
	          default: param.default,
	          isFile: param.type === 'textFile',
	          label: param.label,
	          name: param.name,
	          step: stepVals[param.type],
	          type: inputTypes[param.type]
	        };
	      });
	    }
	  }
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showdown = __webpack_require__(46);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Protocol',
	  props: ['protocol', 'headers'],
	  data: function data() {
	    return {
	      markdown: this.protocol.markdown
	    };
	  },
	
	  computed: {
	    content: function content() {
	      var _this = this;
	
	      return this.headers.filter(function (header) {
	        var headerKey = header[0];
	        return headerKey in _this.markdown && !!_this.markdown[headerKey];
	      }).map(function (item) {
	        var headerKey = item[0];
	        var displayText = item[1];
	        return {
	          key: headerKey,
	          header: displayText,
	          content: _this.makeHtml(_this.markdown[headerKey])
	        };
	      });
	    }
	  },
	  methods: {
	    makeHtml: function makeHtml(markdown) {
	      return new _showdown2.default.Converter().makeHtml(markdown);
	    },
	    hasContent: function hasContent(item) {
	      return item.content !== '';
	    }
	  }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mixins = __webpack_require__(18);
	
	exports.default = {
	  name: 'ProtocolPreview',
	  mixins: [(0, _mixins.scrubMixin)()],
	  props: ['protocol'],
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    link: function link() {
	      return {
	        name: 'protocol',
	        params: {
	          slug: this.protocol._source.slug
	        }
	      };
	    }
	  },
	  methods: {
	    info: function info(protocol, key) {
	      return protocol._source[key];
	    }
	  }
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(34);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(52);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _Breadcrumb = __webpack_require__(214);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Categories = __webpack_require__(48);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _Error404Page = __webpack_require__(217);
	
	var _Error404Page2 = _interopRequireDefault(_Error404Page);
	
	var _Setup = __webpack_require__(228);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _Protocol = __webpack_require__(222);
	
	var _Protocol2 = _interopRequireDefault(_Protocol);
	
	var _EmbeddedApp = __webpack_require__(216);
	
	var _EmbeddedApp2 = _interopRequireDefault(_EmbeddedApp);
	
	var _ParameterizeAndDownload = __webpack_require__(221);
	
	var _ParameterizeAndDownload2 = _interopRequireDefault(_ParameterizeAndDownload);
	
	var _db = __webpack_require__(19);
	
	var _db2 = _interopRequireDefault(_db);
	
	var _util = __webpack_require__(32);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ProtocolView',
	  data: function data() {
	    return {
	      topHeaders: [['author', 'Author'], ['partner', 'Partner Lab'], ['description', 'Description'], ['time-estimate', 'Time Estimate'], ['modules', 'Modules'], ['labware', 'Labware'], ['pipettes', 'Pipettes'], ['reagents', 'Reagents'], ['deck-setup', 'Deck Setup'], ['reagent-setup', 'Reagent Setup'], ['protocol-steps', 'Protocol Steps']],
	      bottomHeaders: [['process', 'Process'], ['notes', 'Additional Notes']],
	      protocol: null,
	      is404: false,
	      downloadUrls: {},
	      origin: null,
	      allTabs: [],
	      currentTab: null
	    };
	  },
	  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	    next(function (vm) {
	      if (from.name === 'category-query') {
	        vm.origin = from;
	      }
	    });
	  },
	
	  computed: {
	    categories: function categories() {
	      return [this.origin ? this.origin.params.category : null, this.origin ? this.origin.params.subCategory : null];
	    },
	    selectedOT1protocol: function selectedOT1protocol() {
	      return this.protocol && this.protocol.protocols && this.protocol.protocols['OT 1 protocol'] && this.protocol.protocols['OT 1 protocol'][0];
	    },
	    selectedOT2protocol: function selectedOT2protocol() {
	      return this.protocol && this.protocol.protocols && this.protocol.protocols['OT 2 protocol'] && this.protocol.protocols['OT 2 protocol'][0];
	    },
	    ot2DeckUrl: function ot2DeckUrl() {
	      var baseUrl = 'https://s3-us-west-2.amazonaws.com/protocol-library-kludge/production/index.html';
	      var selectedOT2protocol = this.selectedOT2protocol;
	
	      var labwareArray = selectedOT2protocol && selectedOT2protocol.labware || [];
	
	      var labware = labwareArray.reduce(function (acc, l) {
	        return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, l.slot, {
	          labwareType: l.type,
	          name: l.name
	        }));
	      }, {});
	
	      var modulesArray = selectedOT2protocol && selectedOT2protocol.modules || [];
	
	      var modules = modulesArray.reduce(function (acc, module) {
	        return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, module.slot, module.name));
	      }, {});
	
	      var encodedJson = window.encodeURI((0, _stringify2.default)({
	        labware: labware,
	        modules: modules
	      }));
	
	      return baseUrl + '?data=' + encodedJson;
	    },
	    protocolData: function protocolData() {
	      var protocolType = this.currentTab === 'ot1' ? 'OT 1 protocol' : 'OT 2 protocol';
	
	      var protocolsOfType = this.protocol && this.protocol.protocols && this.protocol.protocols[protocolType];
	
	      var numProtocolsOfType = protocolsOfType.length;
	      if (protocolsOfType && numProtocolsOfType > 1) {
	        console.warn('Got ' + numProtocolsOfType + ' protocol objects under ' + protocolType + ' key, will only show the first one');
	      }
	
	      var selectedProtocol = protocolsOfType && protocolsOfType[0];
	
	      return {
	        fields: selectedProtocol && selectedProtocol.fields || [],
	        content: selectedProtocol && selectedProtocol.content || '# missing content!?!? something went wrong with Protocol Library',
	        customLabwareDefs: selectedProtocol && selectedProtocol.custom_labware_defs || []
	      };
	    },
	    getIframeSrc: function getIframeSrc() {
	      var protocol = this.protocol;
	      if (!(protocol && protocol.flags['embedded-app'])) {
	        return false;
	      }
	
	      var pattern = /\?(.*)/g;
	      var urlLocationArgs = pattern.exec(window.location.href);
	      var urlSuffix = urlLocationArgs && urlLocationArgs[1] ? '&' + urlLocationArgs[1] : '';
	
	      return protocol && protocol.flags['embedded-app'] + '?timestamp=' + Date.now() + urlSuffix;
	    },
	    tabNames: function tabNames() {
	      return { ot1: 'OT-One', ot2: 'OT-2' };
	    }
	  },
	  components: {
	    Protocol: _Protocol2.default,
	    Setup: _Setup2.default,
	    Categories: _Categories2.default,
	    Breadcrumb: _Breadcrumb2.default,
	    Error404Page: _Error404Page2.default,
	    ParameterizeAndDownload: _ParameterizeAndDownload2.default,
	    EmbeddedApp: _EmbeddedApp2.default
	  },
	  created: function created() {
	    this.fetchProtocol();
	  },
	
	  watch: {
	    '$route': 'fetchProtocol'
	  },
	  methods: {
	    fetchProtocol: function fetchProtocol() {
	      var that = this;
	      var slug = this.$route.params.slug;
	      _db2.default.getProtocol(slug).then(function (protocol) {
	        var ot1FileKey = 'OT 1 protocol';
	        var ot2FileKey = 'OT 2 protocol';
	
	        var baseDownloadUrl = 'https://d894fcc9rk.execute-api.us-west-2.amazonaws.com/ot_api_gw_prod/OpenTrons/Protocols/' + _util2.default.branchName + '/protocols/' + protocol.path.split('/')[1] + '/';
	        var toAbsPath = function toAbsPath(filePath) {
	          return baseDownloadUrl + filePath;
	        };
	        var ot1DownloadUrls = protocol.files[ot1FileKey].map(toAbsPath);
	        var ot2DownloadUrls = protocol.files[ot2FileKey].map(toAbsPath);
	
	        that.protocol = protocol;
	
	        var downloadUrls = {
	          ot1: ot1DownloadUrls[0],
	          ot2: ot2DownloadUrls[0]
	        };
	
	        var allTabs = ['ot2', 'ot1'].filter(function (robotKey) {
	          return downloadUrls[robotKey];
	        });
	
	        that.downloadUrls = downloadUrls;
	        that.allTabs = allTabs;
	        that.currentTab = allTabs ? allTabs[0] : null;
	      }, function (error) {
	        if (error.status === 404) {
	          that.is404 = true;
	        } else {
	          console.error('unhandled error fetching protocol', error);
	        }
	      });
	    },
	    navigateTab: function navigateTab(tab) {
	      this.currentTab = tab;
	    },
	    backToTop: function backToTop() {
	      window.scroll(0, 0);
	    }
	  }
	};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'RecentlyAdded'
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Categories = __webpack_require__(48);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _ProtocolPreview = __webpack_require__(223);
	
	var _ProtocolPreview2 = _interopRequireDefault(_ProtocolPreview);
	
	var _CalloutDocs = __webpack_require__(88);
	
	var _CalloutDocs2 = _interopRequireDefault(_CalloutDocs);
	
	var _mixins = __webpack_require__(18);
	
	var _db = __webpack_require__(19);
	
	var _db2 = _interopRequireDefault(_db);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ResultsView',
	  mixins: [(0, _mixins.scrubMixin)()],
	  data: function data() {
	    return {
	      category: 'N/A',
	      subcategory: 'N/A',
	      query: 'N/A',
	      protocols: []
	    };
	  },
	
	  components: {
	    Categories: _Categories2.default,
	    ProtocolPreview: _ProtocolPreview2.default,
	    CalloutDocs: _CalloutDocs2.default
	  },
	  created: function created() {
	    this.fetchProtocols();
	  },
	
	  watch: {
	    '$route': 'fetchProtocols'
	  },
	  methods: {
	    fetchProtocols: function fetchProtocols() {
	      var that = this;
	      if (this.$route.params.category) {
	        var category = this.$route.params.category;
	        var subcategory = this.$route.params.subCategory;
	        _db2.default.getProtocolsByCategory(category.replace('-', ' '), subcategory ? subcategory.replace('-', ' ') : false).then(function (protocols) {
	          that.protocols = protocols;
	        });
	      } else if (this.$route.query.q) {
	        var query = this.$route.query.q;
	        _db2.default.queryProtocols(query).then(function (response) {
	          that.protocols = response;
	        });
	      }
	    },
	    queryOriginator: function queryOriginator() {
	      var queryOrParams = (0, _keys2.default)(this.$route.params).length > 0 ? this.$route.params : { 'q': this.$route.query.q };
	      this.category = queryOrParams.category;
	      this.subcategory = queryOrParams.subCategory;
	      return queryOrParams;
	    },
	    home: function home() {
	      this.$router.push('/');
	    }
	  },
	  updated: function updated() {
	    window.scrollTo(0, 0);
	  }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mixins = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SearchBar',
	  mixins: [(0, _mixins.scrubMixin)()],
	  data: function data() {
	    return {
	      query: '',
	      selected: 'all-categories'
	    };
	  },
	  methods: {
	    category: function category() {
	      return (0, _keys2.default)(this.$store.state.categories);
	    },
	    submitQuery: function submitQuery() {
	      this.$router.push({ name: 'search-query', query: { q: this.query } });
	    }
	  }
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showdown = __webpack_require__(46);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	var _Container = __webpack_require__(215);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Setup',
	  props: ['protocol'],
	  components: {
	    Container: _Container2.default
	  },
	  data: function data() {
	    return {
	      markdown: this.protocol.markdown,
	      containers: this.protocol.containers,
	      instruments: this.protocol.instruments,
	      rows: [1, 2, 3],
	      columns: ['A', 'B', 'C', 'D', 'E'],
	      selected: null
	    };
	  },
	
	  methods: {
	    makeHtml: function makeHtml(key) {
	      var markdownText = this.protocol.markdown ? this.protocol.markdown[key] : '';
	      return new _showdown2.default.Converter().makeHtml(markdownText);
	    },
	    occupiedSlots: function occupiedSlots() {
	      var slots = this.containers.map(function (c) {
	        return c['slot'];
	      });
	      return slots;
	    },
	    hasContainer: function hasContainer(slot) {
	      return this.occupiedSlots().includes(slot);
	    },
	    getContainer: function getContainer(slot) {
	      var container = this.containers.find(function (element) {
	        return element.slot === slot;
	      });
	      return container;
	    },
	    activateContainer: function activateContainer(slot) {
	      var activeContainer = this.getContainer(slot);
	      this.selected = activeContainer.slot;
	    },
	    deactivateContainers: function deactivateContainers() {
	      this.selected = null;
	    },
	    isActive: function isActive(slot) {
	      return slot === this.selected;
	    },
	    axis: function axis(_axis) {
	      if (_axis === 'a') {
	        return 'center';
	      } else {
	        return 'left';
	      }
	    }
	  }
	};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SiteFooter'
	};

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports) {

	module.exports = {"homeUrl":"https://opentrons.com","subdomainList":[{"name":"Protocol Designer","url":"https://designer.opentrons.com/","linkout":true,"gtm":{"action":"click","category":"toolbar","label":"protocol-designer"}},{"name":"Protocol Library","url":"https://protocols.opentrons.com/","linkout":true,"gtm":{"action":"click","category":"toolbar","label":"protocol-library"}},{"name":"Python API","url":"https://docs.opentrons.com/","linkout":true,"gtm":{"action":"click","category":"toolbar","label":"opentrons-api"}},{"name":"Labware Library","url":"https://labware.opentrons.com/","linkout":true,"gtm":{"action":"click","category":"toolbar","label":"labware-library"}},{"name":"GitHub","url":"https://github.com/Opentrons","linkout":true,"gtm":{"action":"click","category":"toolbar","label":"github-protocols"}},{"name":"Opentrons App","url":"/ot-app","linkout":false,"gtm":{"action":"click","category":"toolbar","label":"opentrons-app"}}],"navigationList":[{"name":"About","links":[{"links":[{"name":"Mission","url":"/about","linkout":false,"gtm":{"action":"click","category":"header","label":"about"}},{"name":"Our Customers","url":"/customers","linkout":false,"gtm":{"action":"click","category":"header","label":"customers"}},{"name":"Press","url":"http://blog.opentrons.com/press","linkout":true,"gtm":{"action":"click","category":"header","label":"press"}},{"name":"Our Team","url":"/team","linkout":false,"gtm":{"action":"click","category":"header","label":"team"}},{"name":"How it works","url":"/how-it-works/","linkout":false,"gtm":{"action":"click","category":"header","label":"how-it-works"}}]}]},{"name":"Products","text":"100% transparent pricing. <a href=\"https://shop.opentrons.com\" target=\"_blank\" rel=\"noopener noreferrer\" data-gtm-category=\"b-header\" data-gtm-label=\"all-products\" data-gtm-action=\"click\">Order online  ›</a>","links":[{"name":"OT-2 LAB ROBOT","links":[{"name":"OT-2 Robot","url":"/ot-2","linkout":false,"gtm":{"action":"click","category":"header","label":"ot-2"}},{"name":"OT-2 Pipettes","url":"/pipettes","linkout":false,"gtm":{"action":"click","category":"header","label":"ot-2-pipettes"}}]},{"name":"OT-2 WORKSTATIONS","links":[{"name":"Nucleic Acid Cleanup","linkout":false,"url":"/workstations/automated-nucleic-acid-cleanup","gtm":{"action":"click","category":"header","label":"workstation-nac"}},{"name":"NGS Library Prep","url":"/workstations/automated-ngs-library-prep/","linkout":false,"gtm":{"action":"click","category":"header","label":"ngs-prep"}}]},{"name":"OT-2 HARDWARE MODULES","links":[{"name":"Thermocycler Module","url":"/modules/thermocycler-module","linkout":false,"gtm":{"action":"click","category":"header","label":"thermocycler"}},{"name":"Temperature Module","url":"/modules/temperature-module","linkout":false,"gtm":{"action":"click","category":"header","label":"tempmod"}},{"name":"Magnetic Module","url":"/modules/magnetic-module","linkout":false,"gtm":{"action":"click","category":"header","label":"magmod"}}]},{"name":"CONSUMABLES & REAGENTS","links":[{"name":"Tips & Filter Tips","linkout":true,"url":"https://shop.opentrons.com/collections/opentrons-tips","gtm":{"action":"click","category":"header","label":"tips"}},{"name":"Reagents","linkout":true,"url":"https://shop.opentrons.com/collections/verified-reagents","gtm":{"action":"click","category":"header","label":"reagents"}},{"name":"Tubes & Vials","linkout":true,"url":"https://shop.opentrons.com/collections/tubes","gtm":{"action":"click","category":"header","label":"tube"}}]},{"name":"VERIFIED LABWARE","links":[{"name":"Lab Plates","linkout":true,"url":"https://shop.opentrons.com/collections/lab-plates","gtm":{"action":"click","category":"header","label":"plates"}},{"name":"Reservoirs","linkout":true,"url":"https://shop.opentrons.com/collections/reservoirs","gtm":{"action":"click","category":"header","label":"reserv"}},{"name":"Tube Racks","linkout":true,"url":"https://shop.opentrons.com/collections/racks-and-adapters","gtm":{"action":"click","category":"header","label":"tubes-racks"}}]}]},{"name":"Applications","url":"/automated-lab-applications/","linkout":false,"gtm":{"action":"click","category":"header","label":"applications"}},{"name":"Blog","url":"https://blog.opentrons.com","linkout":true,"gtm":{"action":"click","category":"header","label":"blog"}},{"name":"Support","text":"<a href=\"https://opentrons.com/contact-support/\"  target=\"_blank\" rel=\"noopener noreferrer\" data-gtm-category=\"b-header\" data-gtm-label=\"contact-support\" data-gtm-action=\"click\">Contact support  ›</a>","links":[{"links":[{"name":"Product Help Center","linkout":true,"url":"https://support.opentrons.com/","description":"Explore our in-depth support articles","gtm":{"action":"click","category":"header","label":"product-help"}},{"name":"OT-2 Start guide","linkout":true,"url":"https://support.opentrons.com/guide-for-getting-started-with-the-ot-2","description":"You recieved your robot, here's what's next","gtm":{"action":"click","category":"header","label":"start-guide"}}]},{"links":[{"name":"Python API","linkout":true,"url":"https://docs.opentrons.com/","description":"Easily write new protocols using Python","gtm":{"action":"click","category":"header","label":"opentrons-api"}},{"name":"Documentation","url":"https://blog.opentrons.com/resources/","description":"Manuals, white papers, eBooks, app notes, etc.","linkout":true,"gtm":{"action":"click","category":"header","label":"documentation"}},{"name":"Return Policy","linkout":true,"url":"https://support.opentrons.com/en/articles/3670461-our-risk-free-return-policy","gtm":{"action":"click","category":"header","label":"return-policy"}},{"name":"Warranty","linkout":true,"url":"https://support.opentrons.com/en/articles/736748-what-is-your-warranty-and-return-policy","gtm":{"action":"click","category":"header","label":"warranty"}}]}]}]}

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzFweCIgaGVpZ2h0PSIyM3B4IiB2aWV3Qm94PSIwIDAgMzEgMjMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU3ICg4MzA3NykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+bmF2IG1vYmlsZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJtb2JpbGVfMzc1cHgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjQuMDAwMDAwLCAtMTkuMDAwMDAwKSIgZmlsbD0iIzAwMDAwMCI+CiAgICAgICAgICAgIDxnIGlkPSIwMC1OYXYiPgogICAgICAgICAgICAgICAgPGcgaWQ9Inx8fC1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDIuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJuYXYtbW9iaWxlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMi4wMDAwMDAsIDE5LjM4NDYxNSkiPgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzEiIGhlaWdodD0iMy4zOTIzMDc2OSIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5IiB4PSIwIiB5PSI5LjM4NjIzNDgyIiB3aWR0aD0iMzEiIGhlaWdodD0iMy4zOTIzMDc2OSIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5LTIiIHg9IjAiIHk9IjE4Ljc3MjQ2OTYiIHdpZHRoPSIzMSIgaGVpZ2h0PSIzLjM5MjMwNzY5IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ot2-animation.7a79452.gif";

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICAgIDxnIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjMxIiBoZWlnaHQ9IjMuMjUiIHg9Ii0zIiB5PSIxMSIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDEyLjUgMTIuNjI1KSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIzMSIgaGVpZ2h0PSIzLjI1IiB4PSItMyIgeT0iMTEuNDI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDEyLjUgMTMuMDUzKSIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(164)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(95),
	  /* template */
	  __webpack_require__(247),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(97),
	  /* template */
	  __webpack_require__(240),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(161)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(100),
	  /* template */
	  __webpack_require__(235),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(101),
	  /* template */
	  __webpack_require__(246),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(165)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(102),
	  /* template */
	  __webpack_require__(251),
	  /* scopeId */
	  "data-v-f12b3ebe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(103),
	  /* template */
	  __webpack_require__(249),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(104),
	  /* template */
	  __webpack_require__(250),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(163)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(105),
	  /* template */
	  __webpack_require__(238),
	  /* scopeId */
	  "data-v-40aa51d6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(107),
	  /* template */
	  __webpack_require__(232),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(108),
	  /* template */
	  __webpack_require__(231),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(109),
	  /* template */
	  __webpack_require__(248),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(160)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(110),
	  /* template */
	  __webpack_require__(233),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(111),
	  /* template */
	  __webpack_require__(241),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(112),
	  /* template */
	  __webpack_require__(245),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(113),
	  /* template */
	  __webpack_require__(236),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(114),
	  /* template */
	  __webpack_require__(239),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(166)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(115),
	  /* template */
	  __webpack_require__(252),
	  /* scopeId */
	  "data-v-f1e31ef8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(162)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(237),
	  /* scopeId */
	  "data-v-2d42c617",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "protocol-page"
	  }, _vm._l((_vm.content), function(item) {
	    return _c('div', {
	      attrs: {
	        "id": item.key
	      }
	    }, [(_vm.hasContent(item)) ? _c('h3', {
	      attrs: {
	        "id": item.key + '-header'
	      }
	    }, [_vm._v("\n      " + _vm._s(item.header) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      attrs: {
	        "id": item.key + '-content'
	      },
	      domProps: {
	        "innerHTML": _vm._s(item.content)
	      }
	    })])
	  }))
	},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "download-parametric"
	  }, [_c('div', {
	    attrs: {
	      "id": "download-protocol-pseudoform"
	    }
	  }, [_vm._l((_vm.protocolFields), function(param) {
	    return (param.isFile) ? _c('div', [_c('label', [_vm._v(_vm._s(param.label))]), _vm._v(" "), _c('input', {
	      attrs: {
	        "name": param.name,
	        "type": "file",
	        "value": ""
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateFile($event, param.name)
	        }
	      }
	    })]) : _vm._e()
	  }), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "download-protocol-form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onDownload($event)
	      }
	    }
	  }, [_vm._l((_vm.protocolFields), function(param) {
	    return (!param.isFile) ? _c('div', [_c('label', [_vm._v("\n          " + _vm._s(param.label) + "\n        ")]), _vm._v(" "), (param.htmlElem === 'input' && !param.isFile) ? _c('input', {
	      attrs: {
	        "name": param.name,
	        "type": param.type,
	        "step": param.step
	      },
	      domProps: {
	        "value": String(_vm.fieldValues[param.name])
	      },
	      on: {
	        "input": function($event) {
	          _vm.fieldValues[param.name] = param.castToNumber ? Number($event.currentTarget.value) : $event.currentTarget.value
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (param.htmlElem === 'select') ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.fieldValues[param.name]),
	        expression: "fieldValues[param.name]"
	      }],
	      attrs: {
	        "name": param.name
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.fieldValues, param.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((param.options), function(opt) {
	      return _c('option', {
	        domProps: {
	          "value": opt.value,
	          "selected": opt.value === opt.default
	        }
	      }, [_vm._v(_vm._s(opt.label))])
	    })) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "id": "download-protocol",
	      "data-gtm-action": _vm.subdomain,
	      "data-gtm-category": "Protocol-Download",
	      "data-gtm-label": _vm.protocolSlug
	    },
	    domProps: {
	      "value": 'Download For ' + _vm.robotTab
	    }
	  })], 2)], 2)])
	},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [(_vm.protocol) ? _c('Breadcrumb', {
	    attrs: {
	      "protocol": _vm.protocol,
	      "categories": _vm.categories
	    }
	  }) : _vm._e(), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "protocol"
	    }
	  }, [_c('aside', {
	    staticClass: "refine"
	  }, [_c('Categories')], 1), _vm._v(" "), _c('section', {
	    staticClass: "results protocol"
	  }, [(_vm.protocol) ? _c('div', {
	    attrs: {
	      "id": "title-block"
	    }
	  }, [_c('div', {
	    staticClass: "protocol-title"
	  }, [_c('h1', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v(_vm._s(_vm.protocol.title))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "selected-protocol"
	  }, [(_vm.is404) ? _c('Error404Page') : _vm._e(), _vm._v(" "), (_vm.protocol) ? _c('span', [_c('Protocol', {
	    attrs: {
	      "protocol": _vm.protocol,
	      "headers": _vm.topHeaders
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "robot-tab"
	  }, [_vm._l((_vm.allTabs), function(tab) {
	    return (_vm.downloadUrls[tab]) ? _c('span', {
	      class: {
	        selected: (tab === _vm.currentTab)
	      },
	      on: {
	        "click": function($event) {
	          _vm.navigateTab(tab)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(_vm.tabNames[tab]) + "\n            ")]) : _vm._e()
	  }), _vm._v(" "), _c('span', {
	    staticClass: "filler"
	  })], 2), _vm._v(" "), _c('h2', {
	    staticClass: "download-protocol-header"
	  }, [_vm._v("Download Protocol:")]), _vm._v(" "), (_vm.protocol.flags['embedded-app'] === false && _vm.downloadUrls[_vm.currentTab]) ? _c('ParameterizeAndDownload', {
	    attrs: {
	      "downloadUrl": _vm.downloadUrls[_vm.currentTab],
	      "protocolSlug": _vm.protocol.slug,
	      "robotTab": _vm.tabNames[_vm.currentTab],
	      "protocolData": _vm.protocolData
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'ot1') ? _c('Setup', {
	    attrs: {
	      "protocol": _vm.selectedOT1protocol
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "ot2_deck_map_wrapper"
	  }, [_c('div', {
	    staticClass: "ot2_deck_map"
	  }, [(_vm.currentTab === 'ot2') ? _c('iframe', {
	    attrs: {
	      "src": _vm.ot2DeckUrl
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('Protocol', {
	    attrs: {
	      "protocol": _vm.protocol,
	      "headers": _vm.bottomHeaders
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.getIframeSrc) ? _c('EmbeddedApp', {
	    attrs: {
	      "src": _vm.getIframeSrc
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.protocol) ? _c('button', {
	    staticClass: "back-to-top",
	    on: {
	      "click": _vm.backToTop
	    }
	  }, [_vm._v("\n        BACK TO TOP\n      ")]) : _vm._e()])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": _vm.linkout ? _vm.url : _vm.homeUrl + _vm.url,
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": ("p-" + (_vm.gtm.category)),
	      "data-gtm-label": _vm.gtm.label,
	      "data-gtm-action": _vm.gtm.action
	    }
	  }, [_vm._v(_vm._s(_vm.name) + "\n  "), (_vm.description) ? _c('div', {
	    staticClass: "nav_sub_description"
	  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "placeable",
	    on: {
	      "mouseover": function($event) {
	        _vm.show = true
	      },
	      "mouseout": function($event) {
	        _vm.show = false
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.containerImg()
	    },
	    on: {
	      "error": _vm.addDefaultSrc
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show) ? _c('span', {
	    staticClass: "tooltip"
	  }, [_vm._v(" \n    " + _vm._s(_vm.placeable.name) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.placeable.slot) + "\n    ")]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "search"
	  }, [_c('div', {
	    attrs: {
	      "id": "protocol-search"
	    }
	  }, [_c('span', {
	    staticClass: "search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query),
	      expression: "query"
	    }],
	    attrs: {
	      "type": "text",
	      "name": "protocol-search",
	      "placeholder": "Search For Protocols"
	    },
	    domProps: {
	      "value": (_vm.query)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.submitQuery()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.query = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "disabled": _vm.query == ''
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitQuery()
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "banner"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('h3', {
	    staticClass: "header"
	  }, [_vm._v("Welcome to the updated Opentrons APIv2 Protocol Library!")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("New to the Protocol Library? A great place to start is to determine whether your lab’s workflow can be handled with our with our Featured or Verified protocols found on the left-hand side of the library.")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('p'), _vm._v(" "), _c('h2', [_vm._v("Featured")]), _vm._v(" "), _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("A majority of lab workflows can be performed with protocols found in the Featured section of the Protocol Library. Find Cherrypicking, Normalization, and Serial Dilution protocols with customizable parameters to fit your lab’s needs.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("Our NGS Library Prep protocols which utilize the popular Illumina Nextera XT and Swift 2s Turbo Kits are also hosted here.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h2', [_vm._v("Verified")]), _vm._v(" "), _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("Opentrons Verified protocols are protocols which have been extensively tested on the OT-2 by our in-house science team. Look for the “App Note” link in the following protocols to find more information on results and analysis using the OT-2.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('ul', {
	    staticClass: "content-copy"
	  }, [_c('lh', [_vm._v("Our Opentrons Verified protocols can be found below:")]), _vm._v(" "), _vm._m(2, false, false), _vm._m(3, false, false), _vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)], 1), _vm._v(" "), _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("If your lab’s workflow isn’t satisfied with these protocols, feel free to explore our other categorized protocols also found on the left-hand side of the library. You can also try using our search bar.")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("All OT-2 compatible workflows including our Featured and Verified protocols can be found here in the Protocol Library. All protocols in the Protocol Library are written using Version 2 of the Opentrons OT-2 Python API. Learn more about OT-2 Python Protocol API Version 2\n      "), _c('a', {
	    attrs: {
	      "href": "https://docs.opentrons.com",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("here")]), _vm._v(".\n    ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("Still didn’t find what you’re looking for? Feel free to reach out to your customer success manager to determine whether\n      "), _c('a', {
	    attrs: {
	      "href": "https://designer.opentrons.com",
	      "target": "_blank",
	      "rel": "nooper noreferrer"
	    }
	  }, [_vm._v("Protocol Designer")]), _vm._v(" or Custom Protocol Development is right for you.\n    ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-el"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/protocol/swift-fully-automated",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("Swift 2S Turbo DNA Library Kit Protocol: Fully-Automated")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-el"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/protocol/swift-2s-turbo-pt1",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("Swift 2S Turbo DNA Library Kit Protocol: Semi-Automated")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-el"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/protocol/omega_biotek_magbind_totalpure_NGS",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("NGS Cleanup and Size Selection with Omega Bio-tek Mag-Bind® TotalPure NGS")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-el"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/protocol/pcr_prep_part_1",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("OT-2 PCR Prep")])])
	}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    attrs: {
	      "id": "nav"
	    }
	  }, [_c('nav', {
	    staticClass: "nav"
	  }, [_c('div', {
	    staticClass: "subdomain_nav_wrapper"
	  }, [_c('div', {
	    staticClass: "nav_container"
	  }, [_c('ul', {
	    staticClass: "subdomain_nav_contents"
	  }, [_c('div'), _vm._v(" "), _c('div', {
	    staticClass: "link_contents"
	  }, _vm._l((_vm.subdomainList), function(subdomainLink) {
	    return _c('li', [_c('app-link', {
	      staticClass: "subdomain_link",
	      attrs: {
	        "link": subdomainLink,
	        "homeUrl": _vm.homeUrl
	      }
	    })], 1)
	  }))])])]), _vm._v(" "), _c('div', {
	    staticClass: "main_nav_wrapper"
	  }, [_c('div', {
	    staticClass: "nav_container"
	  }, [_c('div', {
	    staticClass: "main_nav_contents"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('button', {
	    staticClass: "nav_button",
	    on: {
	      "click": _vm.handleBurgerClick
	    }
	  }, [(!_vm.mobileMenu) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(208),
	      "alt": "Mobile menu open"
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(210),
	      "alt": "Mobile menu close"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "nav_list",
	    class: {
	      nav_list_open: _vm.mobileMenu,
	        nav_list_submenu_open: !!_vm.activeName,
	    }
	  }, [_vm._l((_vm.navigationList), function(item) {
	    return _c('li', {
	      key: item.name,
	      staticClass: "nav_url",
	      class: {
	        nav_url_active: item.name === _vm.activeName,
	          nav_url_parent: !!item.links
	      },
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.handleItemClick(item.name)
	        }
	      }
	    }, [(item.url) ? _c('app-link', {
	      staticClass: "nav_url_name",
	      attrs: {
	        "link": item,
	        "homeUrl": _vm.homeUrl
	      }
	    }) : _vm._e(), _vm._v(" "), (!item.url) ? _c('span', {
	      staticClass: "nav_url_name",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.handleItemClick(item.name)
	        }
	      }
	    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.links && item.name === _vm.activeName) ? _c('div', {
	      staticClass: "dropdown_small",
	      class: {
	        dropdown_small_open: item.name === _vm.activeNameDelay,
	      }
	    }, [_c('button', {
	      staticClass: "nav_sub_name",
	      on: {
	        "click": function($event) {
	          _vm.handleItemClick('')
	        }
	      }
	    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('ul', {
	      staticClass: "nav_sub",
	      class: {
	        nav_sub_support: item.name === 'Support',
	      }
	    }, _vm._l((item.links), function(subitem) {
	      return _c('navigation-sub', {
	        key: subitem.name,
	        attrs: {
	          "subitem": subitem,
	          "homeUrl": _vm.homeUrl
	        }
	      })
	    })), _vm._v(" "), (item.text) ? _c('div', {
	      staticClass: "nav_text",
	      domProps: {
	        "innerHTML": _vm._s(item.text)
	      }
	    }) : _vm._e()]) : _vm._e()], 1)
	  }), _vm._v(" "), _c('a', {
	    staticClass: "nav_contact_button",
	    attrs: {
	      "href": "https://opentrons.com/contact",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n              CONTACT SALES\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "demo_button",
	    attrs: {
	      "href": "https://opentrons.com/demo",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n              SCHEDULE DEMO\n            ")])], 2)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "https://opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "logo",
	      "data-gtm-action": "click"
	    }
	  }, [_c('img', {
	    staticClass: "nav_logo",
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/ot_logo_full.png",
	      "alt": "Opentrons Home"
	    }
	  })])
	}]}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "protocol-setup"
	    }
	  }, [_c('h2', {
	    staticClass: "offset",
	    attrs: {
	      "id": "setup"
	    }
	  }, [_vm._v("Setup")]), _vm._v(" "), _c('div', {
	    staticClass: "setup"
	  }, [_c('div', {
	    attrs: {
	      "id": "deck-list"
	    }
	  }, [_c('h3', [_vm._v("Deck Map")]), _vm._v(" "), _c('h4', [_vm._v("Containers")]), _vm._v(" "), _c('ul', {
	    staticClass: "containers"
	  }, _vm._l((_vm.containers), function(container) {
	    return _c('li', [_vm._v("\n    ["), _c('a', {
	      on: {
	        "mouseenter": function($event) {
	          _vm.activateContainer(container.slot)
	        },
	        "mouseout": function($event) {
	          _vm.deactivateContainers()
	        }
	      }
	    }, [_vm._v(_vm._s(container.slot))]), _vm._v("] " + _vm._s(container.name) + " (" + _vm._s(container.type) + ")\n    ")])
	  })), _vm._v(" "), _c('h4', [_vm._v("Pipettes")]), _vm._v(" "), _c('ul', {
	    staticClass: "instruments"
	  }, _vm._l((_vm.instruments), function(instrument) {
	    return _c('li', [_vm._v("\n        " + _vm._s(instrument.name) + " " + _vm._s(instrument.type) + " (" + _vm._s(_vm.axis(instrument.axis)) + ")\n      ")])
	  })), _vm._v(" "), _c('h3', {
	    attrs: {
	      "id": "reagents"
	    }
	  }, [_vm._v("Reagents")]), _vm._v(" "), _c('div', {
	    staticClass: "reagents",
	    domProps: {
	      "innerHTML": _vm._s(_vm.makeHtml('reagents'))
	    }
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "deck-map"
	    }
	  }, [_c('div', {
	    staticClass: "deck"
	  }, [_c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.columns), function(col) {
	    return _c('div', {
	      staticClass: "deck-col"
	    }, _vm._l((_vm.rows), function(row) {
	      return _c('div', {
	        staticClass: "deck-slot",
	        class: {
	          occupied: _vm.hasContainer(col + row)
	        },
	        attrs: {
	          "id": col + row
	        }
	      }, [(_vm.hasContainer(col + row)) ? _c('Container', {
	        class: {
	          active: _vm.isActive(col + row)
	        },
	        attrs: {
	          "placeable": _vm.getContainer(col + row)
	        }
	      }) : _c('div', {
	        staticClass: "empty"
	      }, [_c('p', [_vm._v(_vm._s(col + row))])])], 1)
	    }))
	  }))])])])])
	},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "breadcrumb"
	  }, [_c('ul', [_vm._l((_vm.links), function(link) {
	    return _c('li', [_c('router-link', {
	      attrs: {
	        "to": link.url
	      }
	    }, [_vm._v(_vm._s(link.name))])], 1)
	  }), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.protocol.title))])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "recently-added"
	  }, [_c('h2', [_vm._v("Recently Added")]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Parametric PCR")]), _vm._v(" "), _c('p', [_vm._v("Author "), _c('a', [_vm._v("Opentrons")])]), _vm._v(" "), _c('p', [_vm._v("Ut sollicitudin viverra volutpat. Pellentesque aliquam hendrerit tempor. Sed ut leo interdum, porttitor nunc a.")]), _vm._v(" "), _c('a', {
	    staticClass: "view-protocol"
	  }, [_vm._v("View Protocol")])])])
	}]}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "nav_sub_item"
	  }, [(_vm.url) ? _c('app-link', {
	    staticClass: "nav_sub_link",
	    attrs: {
	      "link": this.subitem,
	      "homeUrl": _vm.homeUrl,
	      "description": _vm.description
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.url && _vm.name) ? _c('span', {
	    staticClass: "nav_sub_title"
	  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "nav_sub_sub"
	  }, _vm._l((_vm.links), function(subitem) {
	    return _c('navigation-sub', {
	      key: subitem.name,
	      attrs: {
	        "subitem": subitem,
	        "homeUrl": _vm.homeUrl
	      }
	    })
	  }))], 1)
	},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "categories"
	  }, _vm._l((_vm.categories()), function(category) {
	    return _c('div', [_c('h3', [_c('router-link', {
	      staticClass: "category",
	      attrs: {
	        "to": ("/categories/" + (_vm.scrub(category))),
	        "active-class": "active",
	        "exact": ""
	      }
	    }, [_c('a', [_vm._v(_vm._s(category))])])], 1), _vm._v(" "), _vm._l((_vm.subCategories(category)), function(subCategory) {
	      return _c('h4', {
	        staticClass: "subcategories"
	      }, [_c('router-link', {
	        staticClass: "subCategory",
	        attrs: {
	          "to": ("/categories/" + (_vm.scrub(category)) + "/" + (_vm.scrub(subCategory))),
	          "active-class": "active",
	          "exact": ""
	        }
	      }, [_vm._v("\n        " + _vm._s(subCategory) + "\n      ")])], 1)
	    })], 2)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "custom-call-to-action"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Can’t find what you’re looking for?")]), _c('br'), _vm._v("\n    Let us help you with a "), _c('a', {
	    on: {
	      "click": _vm.openChat
	    }
	  }, [_vm._v("custom protocol.")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('h2', [_vm._v("Custom"), _c('br'), _vm._v("Protocol")])])
	}]}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('nav', {
	    staticClass: "breadcrumb",
	    attrs: {
	      "id": "results-nav"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": '/'
	    }
	  }, [_vm._v("Protocol Library")])], 1), _vm._v(" "), (_vm.category) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": ("/categories/" + (_vm.scrub(_vm.category)))
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.category) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.subcategory) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": ("/categories/" + (_vm.scrub(_vm.category)) + "/" + (_vm.scrub(_vm.subcategory)))
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.subcategory) + "\n          ")])], 1) : _vm._e()])]), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "category"
	    }
	  }, [_c('aside', {
	    staticClass: "refine"
	  }, [_c('h2', {
	    on: {
	      "click": function($event) {
	        _vm.home()
	      }
	    }
	  }, [_vm._v("Protocol Library")]), _vm._v(" "), _c('Categories'), _vm._v(" "), _c('CalloutDocs')], 1), _vm._v(" "), _c('section', {
	    staticClass: "results"
	  }, [_c('div', {
	    staticClass: "selected-category"
	  }, [_c('h4', [_vm._v("Results For:\n        "), _vm._l((_vm.queryOriginator()), function(value, key) {
	    return (value != null) ? _c('span', {
	      staticClass: "query"
	    }, [_vm._v("\n        \"" + _vm._s(value) + "\" \n        ")]) : _vm._e()
	  })], 2), _vm._v(" "), _vm._l((_vm.protocols), function(protocol) {
	    return _c('ProtocolPreview', {
	      attrs: {
	        "protocol": protocol
	      }
	    })
	  }), _vm._v(" "), (_vm.protocols.length === 0) ? _c('span', [_vm._v("\n           Don't see the protocol you need? We'll make it for you! Schedule a demo or chat with our Science team "), _c('a', {
	    attrs: {
	      "id": "intercom-chat",
	      "href": "#",
	      "onclick": "window.Intercom('show');",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Intercom",
	      "data-gtm-label": "click"
	    }
	  }, [_vm._v("here")]), _vm._v(".\n           ")]) : _vm._e()], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('iframe', {
	    attrs: {
	      "src": _vm.src,
	      "id": "embedded-app"
	    }
	  }, [_c('p', [_vm._v("Your browser does not support iframes. Please enable iframes or try using a modern browser")])])
	},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('navigation'), _vm._v(" "), _c('SearchBar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('SiteFooter')], 1)
	},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "protocol-results"
	  }, [_c('div', {
	    staticClass: "protocol",
	    attrs: {
	      "id": _vm.protocol._id
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.link,
	      "tag": "h2"
	    }
	  }, [_c('a', [_vm._v(_vm._s(_vm.info(_vm.protocol, "title")))])]), _vm._v(" "), (_vm.info(_vm.protocol, 'time-estimate')) ? _c('div', {
	    attrs: {
	      "id": "time"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.info(_vm.protocol, 'time-estimate')))])]) : _vm._e(), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "author"
	    }
	  }, [_c('span', [_vm._v("Author: " + _vm._s(_vm.info(_vm.protocol, "author")) + " ")]), _vm._v(" "), (_vm.info(_vm.protocol, 'partner')) ? _c('span', [_vm._v("| Partner: " + _vm._s(_vm.info(_vm.protocol, "partner")) + " ")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info(_vm.protocol, 'description')))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "featured-protocol"
	  }, [_c('div', {
	    staticClass: "protocol"
	  }, [_c('h2', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'protocol',
	        params: {
	          slug: _vm.protocol._source.slug
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.protocol._source.title))])], 1), _vm._v(" "), (_vm.info('time-estimate')) ? _c('div', {
	    attrs: {
	      "id": "time"
	    }
	  }, [_vm._v(_vm._s(_vm.info('time-estimate')))]) : _vm._e(), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "author"
	    }
	  }, [_vm._v("Author: " + _vm._s(_vm.protocol._source.author) + "\n      "), (_vm.hasContent('partner')) ? _c('span', {
	    attrs: {
	      "id": "partner"
	    }
	  }, [_vm._v(" | Partner: " + _vm._s(_vm.protocol._source.partner))]) : _vm._e()]), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "preview"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.makeHtml(_vm.protocol._source.markdown.preview))
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('UpdateBanner'), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "landing"
	    }
	  }, [_c('aside', {
	    staticClass: "refine"
	  }, [_c('h2', [_vm._v("Protocol Library")]), _vm._v(" "), _c('Categories'), _vm._v(" "), _c('CalloutDocs')], 1), _vm._v(" "), _c('section', {
	    staticClass: "landing"
	  }, [(_vm.featuredProtocols.length > 0) ? _c('h2', {
	    attrs: {
	      "id": "featured"
	    }
	  }, [_vm._v("Featured Protocols")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.featuredProtocols), function(protocol) {
	    return _c('FeaturedProtocol', {
	      attrs: {
	        "protocol": protocol
	      }
	    })
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "error404"
	  }, [_c('img', {
	    staticClass: "ot2_animation",
	    attrs: {
	      "src": __webpack_require__(209)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('h2', [_vm._v("Protocol not found")]), _vm._v(" "), _c('span', [_vm._v("\n      Are you looking for a version 1 Python Protocol API protocol? All public APIv1 protocols are still available\n      "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocol-delivery.protocols.opentrons.com"
	    }
	  }, [_vm._v("here")]), _vm._v(".\n    ")])])])
	}]}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('section', {
	    staticClass: "social-signup"
	  }, [_c('div', {
	    staticClass: "social-links"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/OpenTrons-Labworks/",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Facebook"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_facebook.png",
	      "alt": "facebook logo"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://twitter.com/OpenTrons_",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Twitter"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_twitter.png",
	      "alt": "twitter logo"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/opentronslab/",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Instagram"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_instagram.png",
	      "alt": "instagram logo"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/channel/UCvMRmXIxnHs3AutkVhuqaQg",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Youtube"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_youtube.png",
	      "alt": "youtube logo"
	    }
	  })])]), _vm._v(" "), _c('h3', [_vm._v("Sign Up For Our Newsletter")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "mc_embed_signup"
	    }
	  }, [_c('form', {
	    staticClass: "validate",
	    attrs: {
	      "action": "//opentrons.us8.list-manage.com/subscribe/post?u=000595683fb96c5fb3c54cf53&id=ba66060a9c",
	      "method": "post",
	      "id": "mc-embedded-subscribe-form",
	      "name": "mc-embedded-subscribe-form",
	      "target": "_blank",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "mc_embed_signup_scroll"
	    }
	  }, [_c('input', {
	    staticClass: "email-newsletter",
	    attrs: {
	      "type": "email",
	      "value": "",
	      "name": "EMAIL",
	      "id": "mce-EMAIL",
	      "placeholder": "email address",
	      "required": "",
	      "data-gtm-action": "input",
	      "data-gtm-category": "Mailchimp",
	      "data-gtm-label": "Enter Email"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "absolute",
	      "left": "-5000px"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "name": "b_000595683fb96c5fb3c54cf53_ba66060a9c",
	      "tabindex": "-1",
	      "value": ""
	    }
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "gray subscribe",
	    attrs: {
	      "type": "submit",
	      "value": "Subscribe",
	      "name": "subscribe",
	      "id": "mc-embedded-subscribe",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Mailchimp",
	      "data-gtm-label": "Newsletter Signup"
	    }
	  })])])]), _vm._v(" "), _c('p', {
	    staticClass: "copyrite"
	  }, [_vm._v("© OPENTRONS 2017")])]), _vm._v(" "), _c('section', {
	    staticClass: "footer-menu"
	  }, [_c('ul', [_c('li', [_vm._v("Products")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/robots"
	    }
	  }, [_vm._v("OT-One")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-2"
	    }
	  }, [_vm._v("OT-2")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/pipettes"
	    }
	  }, [_vm._v("Pipettes")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/modules"
	    }
	  }, [_vm._v("Modules")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-app"
	    }
	  }, [_vm._v("OT App")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/"
	    }
	  }, [_vm._v("Protocol Library")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Company")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/about"
	    }
	  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/team"
	    }
	  }, [_vm._v("Team")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://blog.opentrons.com/"
	    }
	  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/contact"
	    }
	  }, [_vm._v("Contact Us")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "hiring",
	    attrs: {
	      "href": "https://opentrons.com/jobs",
	      "target": "_blank"
	    }
	  }, [_vm._v("WE'RE HIRING")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Resources")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://support.opentrons.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Support")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://support.opentrons.com/getting-started",
	      "target": "_blank"
	    }
	  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://docs.opentrons.com/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Opentrons API")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/Opentrons/opentrons",
	      "target": "_blank"
	    }
	  }, [_vm._v("Open Source")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    staticClass: "buy",
	    attrs: {
	      "href": "https://shop.opentrons.com/"
	    }
	  }, [_vm._v("Buy")])])])])])])
	}]}

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.50b01a9a94b966f80507.js